module.exports = __webpack_public_path__ + "img/users.0cffcca5.svg";